<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".createPdfVierwerModals" id="addPdfViewerBtn"> </button>
    <div class="modal fade bd-example-modal-xl createPdfVierwerModals" id="folderModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">PDF</h5>
                    <button type="button" class="close" id="closeFilePop" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group col-md-12">
                        <!-- <PdfEmbed :source='Pdfpath' style="height: 600px; width: 100%; overflow:auto" /> -->

                        <div>
                            <div v-if="loading" class="loader">
                                <span class="spinner"></span>
                                Loading PDF...
                            </div>

                                <!-- v-show="!loading" -->
                            <PdfEmbed
                                :source='Pdfpath'
                                style="height: 600px; width: 100%; overflow:auto"
                                @rendered="onPdfRendered"
                                @error="onPdfError"
                            />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"  @click.prevent="downloadFile(Pdfpath)">Download</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PdfEmbed from 'vue-pdf-embed'
// import $ from "jquery";
import {
    downloadFile,
} from '../../utils/helper.js'
export default {
    name: 'PdfViewerData',
    components: {
        PdfEmbed,
    },
    data() {
        return {
            Pdfpath: null,
            loading: false,
        }
    },
    async mounted() {
        this.Pdfpath = '';
    },
    methods: {
        downloadFile,
        filePath(path){
            return process.env.VUE_APP_S3_URL+path
        },
        async openPdfViewer(pdf) {
            if (this.$refs.pond) {
                this.$refs.pond.removeFiles();
            }
            this.loading = true;
            this.Pdfpath = pdf;
            document.getElementById('addPdfViewerBtn').click();
        },
        onPdfRendered() {
            this.loading = false
        },
        onPdfError(error) {
            console.error('PDF load error:', error)
            this.loading = false
        },        
    },
}
</script>
<style scoped>
.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #ccc;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 10px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>